import React from 'react'
import PropTypes from 'prop-types'
import { documentPreview } from 'utils/format'
import { Visibility } from '@material-ui/icons'
import { DescItemList } from 'ui-components/DescItemList'
import { DescList } from 'ui-components/DescList'
import { Button } from 'ui-components/Button'
import { Container, GroupDocument } from './styles'

export default function Customer({ customer, onClick }) {
  const handleClick = () => {
    onClick(customer.id)
  }

  return (
    <DescList>
      <Container>
        <DescItemList label="Código">
          {customer.attributes.internal_id}
        </DescItemList>

        <DescItemList label="Nome/Razão Social">
          {customer.attributes.name}
        </DescItemList>

        <GroupDocument>
          <DescItemList label="CPF/CNPJ">
            {documentPreview(customer.attributes.document1)}
          </DescItemList>
          <Button buttonType="icon" onClick={handleClick}>
            <Visibility />
          </Button>
        </GroupDocument>
      </Container>
    </DescList>
  )
}

Customer.propTypes = {
  customer: PropTypes.objectOf(PropTypes.any),
  onClick: PropTypes.func.isRequired,
}

Customer.defaultProps = {
  customer: { attributes: {} },
}
